import BaseModel from './BaseModel';
import MembershipInvoice from './MembershipInvoice';
import moment from 'moment';

/** Class representing a membership. */
class Membership extends BaseModel {
    static STATUS_NONE    = 'none';
    static STATUS_OK      = 'ok';
    static STATUS_PENDING = 'pending';
    static STATUS_REFUSED = 'refused';

    static FREQUENCY_YEAR    = 'year';
    static FREQUENCY_QUARTER = 'quarter';
    static FREQUENCY_MONTH   = 'month';


    constructor(properties) {
        super(properties);

        this.created_at = moment(this.created_at);
        this.updated_at = moment(this.updated_at);

        if ('invoices' in this)
            this.invoices = (this.invoices || []).map(invoice => new MembershipInvoice(invoice));
    }

    static status() {
        return [
            this.STATUS_NONE,
            this.STATUS_PENDING,
            this.STATUS_OK,
            this.STATUS_REFUSED
        ];
    }

    static frequencies() {
        return [
            this.FREQUENCY_MONTH,
            this.FREQUENCY_QUARTER,
            this.FREQUENCY_YEAR
        ];
    }
}

export default Membership;
